<template>
    <div class="add-client">
        <el-dialog
            title="添加客户"
            :visible.sync="showaddclientpicker"
            width="1200px"
            :before-close="handelclose">
            <div class="base-warp" v-loading="loading">
                <div class="head">
                    <el-form label-width="80px" :inline="true" size="mini">
                        <el-form-item label="选择文件">
                            <el-upload
                                class="upload-demo"
                                accept=".xls,.xlsx"
                                action=""
                                ref="upload"
                                :limit="5"
                                :on-change="upload"
                                :auto-upload="false"
                                :show-file-list="false">
                                <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="起始页">
                            第<el-input v-model="pageNo" placeholder="" clearable @change="pagenochange"></el-input>页
                        </el-form-item>
                        <el-form-item label="数量">
                            <el-input v-model="pagesize" placeholder="" clearable @change="pagesizechange"></el-input>条
                        </el-form-item>
                        <el-form-item label="日期">
                            <el-date-picker
                            v-model="adddate"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item >
                            <el-button size="mini" type="primary" icon="el-icon-upload" @click="confirm111">上传</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="table-box">
                     <el-table 
                    :data="tabledata" 
                    border 
                    size="mini"
                    :key="Math.random()"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                        <el-table-column prop="姓名" label="姓名" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="联系方式" label="电话" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="微信/邮箱" label="微信" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="商户需求" label="商户需求" show-overflow-tooltip></el-table-column>
                        <el-table-column label="上传状态" show-overflow-tooltip>
                            <template slot-scope="s">
                                <span v-if="s.row.pushsuccess" class="status text-success">上传成功</span>
                                <span v-if="s.row.pushrepetition" class="status text-danger">重复</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="fpagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
import XLSX from 'xlsx';
export default {
    name: 'AddClient',
    computed: {
        showaddclientpicker: {
            get() {
                return this.$store.getters.getaddclientpicker;
            },
            set(value){
                this.$store.commit('setaddclientpicker', value);
            },
        },
    },
    data() {
        return {
            clients: [],
            tabledata: [],
            pageNo: this.random(1, 1500),
            pagesize: this.random(80, 200),
            adddate: '',
            loading: false,
            timmer: '',
            i: 0,
            fpageNo: 0,
            fpagesize: 20,
            total: 0,
        }
    },
    mounted () {
        this.total = this.pagesize;
    },
    methods: {
        currentChange(page) {
            this.fpageNo = page;
            var start = (this.fpageNo-1)*this.fpagesize;
            this.tabledata = this.clients.slice(start, start+this.fpagesize)
        },
        confirm111() {
            if (this.clients.length==0){
                this.$confirm('请选择选择数据表')
                return;
            }
            if (!this.adddate) {
                this.$confirm('请选择日期')
                return;
            }
            this.timmer = setInterval(()=>{
                if (this.i>= this.pagesize) clearInterval(this.timmer);
                var client = this.clients[this.i];
                var params = {
                    adddate: this.adddate,
                    mold: client['板块']||'',
                    enterprise: client['企业']||'',
                    cname: client['名称']||'',
                    name: client['姓名']||'',
                    sex: client['性别']||'',
                    job: client['职务']||'',
                    tel: client['联系方式']||'',
                    wechart: client['微信/邮箱']||'',
                    need: client['商户需求']||'',
                }
                this.$api.addProjectClient(params).then(
                    data=>{
                        this.$message({
                            type: 'success',
                            message: data,
                        })
                        if (data=='客户已存在') this.clients[this.i].pushrepetition = true;
                        if (data=='添加'+this.clients[this.i]['name']+'成功') this.clients[this.i].pushsuccess = true;
                        this.i++;
                    }
                )
            },200);
        },
        pagenochange() {
            var data = this.tabledata;
            let start = (this.pageNo*1-1)*this.pagesize;
            var clients = data.slice(start, start+this.pagesize);
            this.clients = clients;
        },
        pagesizechange() {
            var data = this.tabledata;
            let start = (this.pageNo*1-1)*this.pagesize;
            var clients = data.slice(start, start+this.pagesize);
            this.clients = clients;
        },
        handelclose() {
            this.$confirm('是否确定关闭?')
                .then(_=>{
                    this.$store.commit('setaddclientpicker', false);
                })
                .catch(_ => {});
        },
        upload(file,fileList){
            this.fileContent = file.raw
            const fileName = file.name
            const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
                if (this.fileContent) {
                if (fileType === 'xlsx' || fileType === 'xls') {
                    this.loading = true;
                    this.importfile(this.fileContent)
                } else {
                    this.$message({
                        type: 'warning',
                        message: '附件格式错误，请重新上传！'
                    })
                }
                } else {
                this.$message({
                    type: 'warning',
                    message: '请上传附件！'
                })
            }
        },
        importfile (obj) {
            const that = this;
            var fileReader = new FileReader();
            fileReader.onload = function(ev) {
                try {
                    var data = ev.target.result,
                    workbook = XLSX.read(data, {
                        type: 'binary'
                    }), // 以二进制流方式读取得到整份excel表格对象
                    persons = []; // 存储获取到的数据
                } catch (e) {
                    console.log('文件类型不正确');
                    return;
                }
                // 表格的表格范围，可用于判断表头是否数量是否正确
                const wsname = workbook.SheetNames[0];//取第一张表
                const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容
                that.loading = false;

                var start = (that.pageNo-1)*that.pagesize;
                that.clients = ws.slice(start, start+that.pagesize);

                that.tabledata = that.clients.slice(0, that.fpagesize);
                console.log(that.clients)
                console.log(that.tabledata);
            };
            // 以二进制方式打开文件
            fileReader.readAsBinaryString(obj);
        },
        random(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>